import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import './Main.css';
import NewsSection from './NewsSection/NewsSection';
import EventSection from './EventSection/EventSection';
import BandSection from './BandSection/BandSection';
import PhotoSection from './PhotoSection/PhotoSection';
import DiscographySection from './DiscographySection/DiscographySection';
import VideoSection from './VideoSection/VideoSection';
import ShopSection from './ShopSection/ShopSection';
import ContactSection from './ContactSection/ContactSection';

class Main extends Component {
  render() {
    return (
      <div className="main">
        <Switch>
          <Route exact path="/"><Redirect push to="/novinky" /></Route>
          <Route path="/novinky" component={NewsSection} />
          <Route path="/akce" component={EventSection} />
          <Route path="/kapela" component={BandSection} />
          <Route path="/fotky" component={PhotoSection} />
          <Route path="/diskografie" component={DiscographySection} />
          <Route path="/videa" component={VideoSection} />
          <Route path="/suvenyry" component={ShopSection} />
          <Route path="/kontakt" component={ContactSection} />
        </Switch>
      </div>
    );
  }
}

export default Main;